import { getUserInfo } from 'shared/infrastructure/storage'

const hasPermission = () => {
  const userInfo = getUserInfo()
  const storageProducts = userInfo.login.user.products

  if (storageProducts) {
    const storageProductsArray = storageProducts.split(' | ')
    const products = storageProductsArray.map(storageProduct => storageProduct)
    return products.filter(product => product)
  }

  return []
}

const isProductAvailable = productName => {
  const productsAvailable = hasPermission()
  return productsAvailable.includes(productName)
}

export { hasPermission, isProductAvailable }
